<!--
 * @Desc: 业务员扫码记录
 * @Author: may.li
 * @Date: 2023-03-09 08:34:33
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-20 08:49:12
-->
<template>
	<div class="page page_fans page_adress">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item-t">
						<div class="item_l">
							<div class="user_name">绑定人：{{ item.agent_name }}</div>
						</div>
						<div class="item_r">{{ item.created_at }}</div>
					</div>
					<div class="qrcode-num">二维码编号：{{ item.qrcode_num }}</div>
				</div>
			</div>
		</van-list>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false
		}
	},
	created(){
		this.token = this.$store.getters.token;
	},
	methods: {
		/**
		 * @name: 获取记录
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size
			};
			this.$api.salesman.saomalog(params).then(res=>{
				if(res.code == 200){
					let list = res.result.saomalog;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i]);
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
					this.$toast(res.message);
				}
			})
		}
	},
}
</script>
<style scoped>
	.page_fans .list .item{
		display: block;
		padding: 0.4rem 0.53rem 0.4rem 0;
		height: auto;
	}
	.page_fans .list .item-t{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.page_fans .list .item .user_name{
		max-width: 5rem;
	}
	.page_fans .list .item .qrcode-num{
		padding-top: .2rem;
		padding-left: .25rem;
	}
</style>